// extracted by mini-css-extract-plugin
export default {"body":"layout_body__NI7rm","header":"layout_header__QE1r-","info":"layout_info__r8od-","layoutchildren":"layout_layoutchildren__llTYJ"};